import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import Renewable from 'components/renewables/Renewable';
import PageWrapper from 'components/utils/PageWrapper';
import Renewables from 'pages/Renewables';
import renewablesPlaceholder from '../images/wind-unselected.png';

export const renewablesRoutes = {
    path: '/renewables',
    element: (
        <PageWrapper titleId="renewables_title">
            <Renewables type="renewables" key="renewables" />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={renewablesPlaceholder} page="Wind Asset" noun="configuration" />,
        },
        {
            path: ':renewableId',
            element: <Renewable />,
        },
    ],
};
